import { useEffect, useState } from "react";

// هوک مشترک برای دراپ‌دان‌های react-select با قابلیت جست‌وجو.
// فعلاً روی لیست محلی فیلتر می‌کند؛ چون دیتای واقعی (مثلاً ۱۷۶۰ ردیف کالا) از API می‌آید،
// کافی است تابع fetch را بعداً به‌جای فیلتر محلی، به یک فراخوانی API جست‌وجو با debounce وصل کرد.
export function useSearchableOptions<T>(
  source: T[],
  getLabel: (item: T) => string,
  getValue: (item: T) => string,
  debounceMs = 250,
) {
  const [query, setQuery] = useState("");
  const [options, setOptions] = useState(
    (Array.isArray(source) ? source : []).map((item) => ({ value: getValue(item), label: getLabel(item) })),
  );

  useEffect(() => {
    // قبلاً این افکت فقط به query وابسته بود، پس وقتی source بعد از mount (نتیجه‌ی fetch) پر
    // می‌شد، options هرگز به‌روز نمی‌شد مگر کاربر چیزی تایپ می‌کرد. حالا source هم در وابستگی‌هاست
    // تا به‌محض رسیدن دیتا، گزینه‌ها بدون نیاز به جست‌وجو نمایش داده شوند.
    const timeout = setTimeout(() => {
      const safeSource = Array.isArray(source) ? source : [];
      const filtered = query
        ? safeSource.filter((item) => getLabel(item).toLowerCase().includes(query.toLowerCase()))
        : safeSource;
      setOptions(
        filtered.map((item) => ({
          value: getValue(item),
          label: getLabel(item),
        })),
      );
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, debounceMs);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, source]);

  return { options, onInputChange: setQuery };
}

export default useSearchableOptions;
